import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ShoppingBag } from "lucide-react";
import { useCjCart } from "../../context/CjCartContext";

export const CjCartFab = () => {
  const { count } = useCjCart();
  const loc = useLocation();
  if (count === 0 || !loc.pathname.startsWith("/market")) return null;
  return (
    <Link to="/market/cart" data-testid="cj-cart-fab"
      className="fixed bottom-24 right-5 z-40 bg-black text-white rounded-full h-14 w-14 flex items-center justify-center shadow-2xl hover:bg-taven-gold hover:text-black transition-colors">
      <ShoppingBag className="w-6 h-6" />
      <span className="absolute -top-1 -right-1 bg-taven-orange text-white text-[11px] font-bold min-w-[20px] h-5 flex items-center justify-center rounded-full px-1" data-testid="cj-cart-count">{count}</span>
    </Link>
  );
};

export default CjCartFab;
